/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ERP Browser BFF Auth API
 * Browser-facing authentication and session contract derived from the authoritative
 * backend gateway contract. Login and logout are top-level browser-navigation endpoints,
 * not ordinary fetch APIs.
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  BeginBffLoginParams,
  CsrfResponse,
  SessionResponse,
  SubmitBffLogoutBody,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getGetBffSessionUrl = () => {
  return `/bff/session`;
};

/**
 * Returns 200 for anonymous and authenticated sessions. Never redirects to login.
 * @summary Get current browser session state
 */
export const getBffSession = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<SessionResponse> => {
  return customFetch<SessionResponse>(getGetBffSessionUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBffCsrfUrl = () => {
  return `/bff/csrf`;
};

/**
 * Fetch after confirming an authenticated session through `/bff/session`.
 * @summary Get CSRF request data
 */
export const getBffCsrf = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CsrfResponse> => {
  return customFetch<CsrfResponse>(getGetBffCsrfUrl(), {
    ...options,
    method: "GET",
  });
};

export const getLaunchBffAccountConsoleUrl = () => {
  return `/bff/account`;
};

/**
 * Top-level browser navigation endpoint. Do not invoke with fetch.
 * Requires an authenticated ERP BFF session and redirects only to the fixed,
 * server-configured Keycloak Account Console URI. It accepts no query parameters.
 * A 503 response is reserved for a future dynamic configuration failure; invalid
 * static configuration fails gateway startup instead.
 * @summary Open Keycloak Account Console
 */
export const launchBffAccountConsole = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<unknown> => {
  return customFetch<unknown>(getLaunchBffAccountConsoleUrl(), {
    ...options,
    method: "GET",
  });
};

export const getBeginBffLoginUrl = (params?: BeginBffLoginParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/bff/login?${stringifiedParams}` : `/bff/login`;
};

/**
 * Top-level browser navigation endpoint. Do not invoke with fetch.
 * The gateway validates returnTo before login and keeps it only in a bounded,
 * expiring, one-time server-side OAuth-state transaction.
 * @summary Begin OIDC login
 */
export const beginBffLogin = async (
  params?: BeginBffLoginParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<unknown> => {
  return customFetch<unknown>(getBeginBffLoginUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getSubmitBffLogoutUrl = () => {
  return `/logout`;
};

/**
 * Submit as a top-level application/x-www-form-urlencoded browser form.
 * The `_csrf` form parameter is canonical; unsafe non-navigation clients may use
 * the CSRF header supplied by `/bff/csrf` instead.
 * @summary Log out browser session
 */
export const submitBffLogout = async (
  submitBffLogoutBody: SubmitBffLogoutBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<unknown> => {
  const formUrlEncoded = new URLSearchParams();
  formUrlEncoded.append(`_csrf`, submitBffLogoutBody._csrf);

  return customFetch<unknown>(getSubmitBffLogoutUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/x-www-form-urlencoded", ...options?.headers},
    body: formUrlEncoded,
  });
};

export const getCompleteBffLogoutUrl = () => {
  return `/logged-out`;
};

/**
 * Public browser redirect target after OpenID Provider logout. Always redirects to
 * fixed SPA-owned `/signed-out` route. It accepts no redirect destination.
 * @summary Complete browser logout
 */
export const completeBffLogout = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<unknown> => {
  return customFetch<unknown>(getCompleteBffLogoutUrl(), {
    ...options,
    method: "GET",
  });
};
